module.exports = {
	"Info": " I had contact with programming for about six years till now, and 've been actively coding for four years using GitHub. I have IT technician diploma, and BA in English Philology. My specialisation is web application programming in JavaScript. Technologies I have been working with for the longest time are: React, Node, Next.js. What is more, I feel comfortable with MERN and AWS. I also created few scripts in python, and programmed microcontrollers. Besides programming, my interests are economics, investing and IoT.",
	"Technologies": {
		"title": "MyStack",
		"technologies": [
			[
				"React.js",
				"The most important technologies I use in the field of Front is React.js. React's use of syntactic sugar amazed me. I wrote a couple websites in it, and explored MDN. I utilized the following technologies with React:  firebase, cloudinary, facebook SDk, bootstrap/material-UI."
			],
			[
				"Next.js",
				"Next.js is tool which I choose over react since it made building apis simpler and improved how quickly images or subpages loaded. My most extensive application to date was a monopoly clone that I created in it. I tested express and mongodb after using Firebase and Recoil. Naturally, I also tested the rendering options provided by next, but I didn't make any applications for the audience."
			],
			[
				"MERN",
				"Recently I started work in MERN stack, after working with Node and next.js so it was not so hard to grasp the groundings. I understand how middleware works and JWT. However, I feel that there still more to learn in there, and it will be learned in the future."
			],
			[
				"Node.js",
				"My adventure with Node.js began while rewriting one of my apps written in react (family tree). At the end, the application was in react, but the adventure with Node has only just begun. Later, Node.js served me long and pleasant hours spent on user simulation using pupetter or mineflayer."
			],
			[
				"Additional",
				"I wrote few work optimalization scripts in python, one for resizing images in folder and automatically adding breakpoints to css. Now I'am waiting for Raspberry Pi Pico W in order to start some projects in  micro python utylizing python-api. Besides, I created rc car from scratch in arduino running on programmed atmega, soldered esc and nrf24l01 modules to it. This build required from me to get used to C-alike syntax and shown me practically how wireless data transfer works."
			]
		]
	},
	"title1": "SoftSkills",
	"SoftList": [
		"Fluent English",
		"Passionate",
		"Heavy Googler",
		"Persevering"
	],
	"title2": "Tools",
	"Tools": [
		"Scrum",
		"Figma",
		"VSCode",
		"CMD",
		"Postman"
	],
	"title3": "Background",
	"ShortStory": "Programming fascinated me when I was in middle school, creating things straight out of dust gave plenty of fun. First project which is in my memory was simple login mechanism written in PHP, JS, html and jQuery. After that in college I started Arduino programming, I wanted to create drone but created Rc car instead - everyone makes mistakes :). College gave me groundings of LAMP stack, and how internet was build that day. After college I went to English Philology studies so I could code simultaneously with getting a degree, besides degree studies gave me business world insights, and I wrote there my diploma paper titled: 'Software Startups: Theory and Practice', due to which monopoly web app was created. "
};


//////////////////
// WEBPACK FOOTER
// ./src/data/eng.json
// module id = 35
// module chunks = 0